import React from 'react';
import AboutOne from '../../components/About/AboutOne';
import AboutThree from '../home-3/AboutThree';
const About = () => {
    return (
        <>
            {/* About One Start */}
            <AboutThree />
            {/* About One End */}
        </>
    );
}

export default About;
